/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const channelDeliveryOutcomeDataReasonSchema = z.enum([
	'not_opted_in',
	'no_email_address',
	'no_email_body',
	'whatsapp_not_configured',
	'whatsapp_template_language_missing',
])

export type ChannelDeliveryOutcomeDataReasonSchema = z.infer<typeof channelDeliveryOutcomeDataReasonSchema>
